import { resourceText } from 'src/app/shared/services/localization';
import { languageInfo } from 'src/app/shared/services/localization';
import { ChurchHistoryService } from 'src/app/shared/services/church-history.service';
import { NavigationPanelService } from 'src/app/shared/services/navigation-panel.service';
import { AuthService } from '../account/auth.service';
import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { SimpleTenant } from 'src/app/shared/models/simple-tenant.model';
import { GlobalService } from 'src/app/shared/services/global.service';
import { IdentityService } from 'src/app/shared/services/identity.service';
import { LinkHandlerService } from 'src/app/shared/services/link-handler.service';
import { TenantService } from 'src/app/tenant/tenant.service';
import { churchCalendar } from 'src/app/shared/services/church-calendar';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit, OnDestroy {
  private languageSubscription?: Subscription;
  private preferenceUserId = "";
  private preferenceGeneration = 0;

  tenant: SimpleTenant = {} as SimpleTenant;
  languages = ['English','Arabic'];
  changingLanguage = false;
  availableLanguages: string[] = [];
  personalLanguages: string[] = [];
  addingLanguage = false;
  languageSaveError = false;
  private get churchLanguages(): string[] {
    let church: string[] = [];
    try { const values = JSON.parse(this.tenant.additionalLanguages || '[]'); if (Array.isArray(values)) church = values.filter(value => typeof value === 'string'); } catch {}
    return [...new Set(['en', this.tenant.language || 'en', ...church].map(l => languageInfo(l).code))];
  }
  private refreshLanguageMenu() {
    const requested = [...this.churchLanguages, ...this.personalLanguages, this.globalService.currentLanguage];
    const available = new Set(this.availableLanguages.map(l=>languageInfo(l).code));
    this.languages = [...new Set(requested.filter(Boolean).map(l=>languageInfo(l).code))].filter(l=>available.has(l));
  }
  get otherLanguages() { return this.availableLanguages.map(l=>languageInfo(l).code).filter(l=>!this.languages.includes(l)); }
  private get languageStorageKey() { return 'AdditionalLanguages:' + (this.preferenceUserId || 'guest'); }
  canRemoveLanguage(language: string) {
    const code = languageInfo(language).code;
    return !this.churchLanguages.includes(code) && (this.personalLanguages.some(l => languageInfo(l).code === code) || this.isSelectedLanguage(code));
  }
  async removeLanguage(language: string) {
    if (this.changingLanguage || !this.canRemoveLanguage(language)) return;
    const code = languageInfo(language).code;
    const next = this.personalLanguages.filter(l => languageInfo(l).code !== code);
    const removingSelected = this.isSelectedLanguage(code);
    const selected = removingSelected ? languageInfo(this.tenant.language || 'en').code : languageInfo(this.globalService.currentLanguage).code;
    const generation = this.preferenceGeneration;
    const storageKey = this.languageStorageKey;
    this.changingLanguage = true; this.languageSaveError = false;
    try {
      if (this.identityService.authenticated) await this.globalService.saveLanguagePreferences(selected, next);
      if (generation !== this.preferenceGeneration) return;
      localStorage.setItem(storageKey, JSON.stringify(next));
      this.personalLanguages = next;
      if (removingSelected) {
        localStorage.setItem('Language', selected);
        this.globalService.currentLanguage = languageInfo(selected).name;
      }
      this.refreshLanguageMenu();
      if (removingSelected) { this.globalService.clearCurCache = true; window.location.reload(); }
    } catch { if (generation === this.preferenceGeneration) this.languageSaveError = true; }
    finally { this.changingLanguage = false; }
  }
  async addLanguage(language: string) {
    if (this.changingLanguage) return;
    this.changingLanguage = true; this.languageSaveError = false;
    const next = [...new Set([...this.personalLanguages,languageInfo(language).code])];
    try {
      if (this.identityService.authenticated) await this.globalService.saveLanguagePreferences(this.globalService.currentLanguage,next);
      this.personalLanguages = next; localStorage.setItem(this.languageStorageKey, JSON.stringify(next));
      this.refreshLanguageMenu(); this.addingLanguage = false;
    } catch { this.languageSaveError = true; }
    finally { this.changingLanguage = false; }
  }

  constructor(public globalService: GlobalService,
      private router: Router,
      public identityService: IdentityService, public panels: NavigationPanelService, public authService: AuthService,
      private linkHandler: LinkHandlerService,
      private tenantService: TenantService, private churchHistory: ChurchHistoryService) { }

  async ngOnInit() {
  try {
    this.tenant = await this.tenantService.getSimpleTenant();
    if (!this.tenant.deleted) this.churchHistory.remember(this.tenant.subdomain, this.tenant.name);
    try {
      this.availableLanguages = await this.globalService.getLanguages();

    } catch { this.availableLanguages = [this.tenant.language || 'English','English']; }
    this.languageSubscription = this.authService.user.subscribe(user => { void this.loadLanguagePreferences(user?.id || ''); });
    this.refreshLanguageMenu();
    void this.panels.refresh();
  } catch (err) {
    console.error('Footer tenant load failed', err);
    this.tenant = {} as any; // fallback
  }

  }

  private async loadLanguagePreferences(userId: string) {
    this.preferenceUserId = userId;
    const generation = ++this.preferenceGeneration;
    try {
      const stored = JSON.parse(localStorage.getItem(this.languageStorageKey) || '[]');
      this.personalLanguages = Array.isArray(stored) ? stored.filter(value => typeof value === 'string') : [];
    } catch { this.personalLanguages = []; }
    this.refreshLanguageMenu();
    if (!userId) return;
    try {
      const preferences = await this.globalService.getLanguagePreferences();
      if (generation !== this.preferenceGeneration) return;
      this.personalLanguages = preferences.additionalLanguages || [];
      localStorage.setItem(this.languageStorageKey, JSON.stringify(this.personalLanguages));
      if (!localStorage.getItem('Language') && preferences.language) {
        const resources = await this.globalService.getResources(preferences.language);
        if (generation !== this.preferenceGeneration) return;
        this.globalService.resourceArr = resources;
      }
      this.refreshLanguageMenu();
    } catch { /* Keep this account's cached choices while offline. */ }
  }
  ngOnDestroy() { this.preferenceGeneration++; this.languageSubscription?.unsubscribe(); }

  Home() {
    this.globalService.Initialize();
    var timer = 0;
    if (this.globalService.datePicker != null) {
      this.globalService.datePicker.close();
      this.globalService.datePicker = null;
      timer = 150;
    }
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    const home = this.identityService.authenticated && this.identityService.permissions?.includes('Check-in') ? '/usher/check-in' : '/home';
    setTimeout(() => this.router.navigate([home]), timer);
  }    

  MyProfile() {
    this.globalService.Initialize();
    var timer = 0;
    if (this.globalService.datePicker != null) {
      this.globalService.datePicker.close();
      this.globalService.datePicker = null;
      timer = 150;
    }
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    setTimeout(() => this.router.navigate(['/myprofile']), timer);
  }  

  Notification() {
    this.globalService.Initialize();
    var timer = 0;
    if (this.globalService.datePicker != null) {
      this.globalService.datePicker.close();
      this.globalService.datePicker = null;
      timer = 150;
    }
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    setTimeout(() => this.router.navigate(['/notifications']), timer);
  }    

  Calendar() {
    this.globalService.Initialize();
    const currentChurch = this.tenantService.getTenant();
    const tenant = this.globalService.simpleTenant?.subdomain === currentChurch ? this.globalService.simpleTenant : this.tenant;
    if (tenant?.subdomain !== currentChurch) {
      // Tenant switching/loading must not open the previous church's URL.
      this.router.navigate(['/' + currentChurch + '/home']);
      return;
    }
    const destination = churchCalendar(tenant);
    var timer = 0;
    if (this.globalService.datePicker != null) {
      this.globalService.datePicker.close();
      this.globalService.datePicker = null;
      timer = 150;
    }
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    if (destination.external) {
      // Keep external opening in the tap handler so browser popup protection
      // does not reject it, including when a date picker was open.
      void this.linkHandler.open(destination.url);
    } else {
      setTimeout(() => this.router.navigate([destination.url]), timer);
    }
  }

  accountLabel(label: string): string {
    return this.globalService.translateText(label);
  }

  SwitchChurch() {this.goTo('/' + (this.tenant.subdomain || this.globalService.subdomain) + '/switch-tenant');}

  SystemMenu() {this.panels.toggle('system');}
  Language() {this.panels.toggle('language');}
  languageLabel(language: string) { return languageInfo(language).nativeName; }
  languageFlag(language: string) {return '';}
  isSelectedLanguage(language: string) { return languageInfo(this.globalService.currentLanguage).code === languageInfo(language).code; }
  async setLanguage(language: string) {
    if(this.changingLanguage)return;
    if(this.isSelectedLanguage(language)){this.panels.close();return;}
    this.changingLanguage=true;this.languageSaveError=false;
    try {
      const code=languageInfo(language).code;
      if(this.identityService.authenticated)await this.globalService.saveLanguagePreferences(code,this.personalLanguages);
      localStorage.setItem('Language',code);
      this.globalService.currentLanguage=languageInfo(code).name;this.globalService.clearCurCache=true;window.location.reload();
    } catch {this.languageSaveError=true;this.changingLanguage=false;}
  }
  goTo(path: string) {
    this.panels.close(false);
    this.globalService.clearCurCache=true;
    this.globalService.isBack=false;
    this.globalService.datePicker?.close();
    this.globalService.datePicker=null;
    this.router.navigate([path]);
  }
  forgetError = '';
  forgetting = false;
  async forgetCheckinDevice() {
    if (this.forgetting) return;
    this.forgetting = true; this.forgetError = '';
    try { await this.authService.checkinDevices.forget(); this.Logout(); }
    catch { this.forgetError = resourceText('UNABLE_TO_FORGET_THIS_DEVICE_CHECK_YOUR_CONNECTION_AND_TRY_AGAIN'); }
    finally { this.forgetting = false; }
  }
  Logout() {this.panels.close(false);this.globalService.clearCurCache=true;this.globalService.isBack=false;this.authService.logout(1);this.identityService.authenticated=false;this.identityService.permissions=[];void this.panels.refresh();this.router.navigate(['/home']);}
  @HostListener('document:keydown.escape') onEscape() {if(this.panels.panel)this.panels.close();}

  CheckIn() {
    this.globalService.Initialize();
    var timer = 0;
    if (this.globalService.datePicker != null) {
      this.globalService.datePicker.close();
      this.globalService.datePicker = null;
      timer = 150;
    }
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    if (this.identityService.authenticated == true && this.identityService.permissions?.includes('Check-in'))
      setTimeout(() => this.router.navigate(['/usher/check-in']), timer);
    else
      setTimeout(() => this.router.navigate(['/fast-checkin']), timer);
  }  

  isIOS() {
    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      return true;
    }
    return false;
  }
}
